<template lang="pug">
#event-registration-modal.modal-card
  header.modal-card-head
    p.modal-card-title {{ event.title }}
  //- section.modal-card-body
  //-   .notification Sign up for <b>{{  }}</b> on <b>{{  }}</b>
  b-table(
    :data="sortedRegistrationFields"
  )
    template(slot-scope="props")
      b-table-column
        small {{ props.row.label }}
      b-table-column
        span(v-if="props.row.field_type === 'checkbox' || props.row.field_type === 'waiver'")
          b-tag(
            :type="props.row.value === 'true' ? 'is-success' : 'is-danger'"
          ) {{ props.row.value === 'true' ? 'Yes' : 'No' }}
        span(v-else-if="props.row.field_type === 'date'") {{ props.row.value | date('MMMM D, YYYY') }}
        span(v-else) {{ props.row.value }}
  footer.modal-card-foot
    //- a.button.is-success(
    //-   :class="{ 'is-loading': settings.submitting }"
    //-   :disabled="settings.submitting"
    //-   @click="resend"
    //- ) Resend Confirmation
    a.button.is-danger(
      :class="{ 'is-loading': settings.deleting }"
      :disabled="settings.deleting"
      @click="confirmDelete"
    ) Delete
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'event-registration-modal',
  computed: {
    ...mapGetters({
      event: getters.GET_EVENT,
      registration: getters.GET_EVENT_REGISTRATION,
    }),
    sortedRegistrationFields() {
      return _.sortBy(this.registration.registration_fields, ['sort_order']);
    },
  },
  data() {
    return {
      settings: {
        deleting: false,
        submitting: false,
      },
    };
  },
  methods: {
    confirmDelete() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message: 'Deleting this sign up cannot be undone and any associated orders will also be deleted.',
        type: 'is-danger',
        hasIcon: true,
        confirmText: 'Yes, Delete',
        onConfirm: () => this.delete(),
      });
    },
    async delete() {
      if (!this.settings.deleting) {
        this.settings.deleting = true;
        await this.$store.dispatch(actions.DO_DELETE_EVENT_REGISTRATION, {
          id: this.registration.id,
        });
        this.$parent.close();
        this.$store.commit(mutations.SET_EVENT_REGISTRATION_REFRESH, true);
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-success',
          message: 'Registration deleted',
        });
        this.settings.deleting = false;
      }
    },
  },
};
</script>

<style lang="scss">
#event-registration-modal {
  .b-table {
    background-color: white;
    table.table {
      padding-bottom: 1.25rem;
      tr {
        td, th {
          &:first-child {
            padding-left: 20px;
          }
          &:last-child {
            padding-right: 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EventRegistrationModal.vue